<template>
  <div class="ma-4">
    <ClientNav />
    <div class="ma-2 mt-10">
      <form-dialog
        ref="form-dialog"
        :title="title"
        @save-item="save"
        @update-item="update"
        :isAuditorRole="isAuditorRole"
      />
      <div class="ma-1">
        <v-alert
          dense
          border="top"
          colored-border
          type="info"
          color="primary"
          elevation="2"
        >
          <span class="bm-info">
            <v-row align="center" no-gutters>
              <strong>Seizures</strong> <br />
              <v-spacer></v-spacer>
              <v-col class="shrink">
                <v-btn
                  color="primary"
                  outlined
                  x-small
                  @click="showInfo1 = !showInfo1"
                >
                  {{ showInfo1 ? "hide" : "show" }}
                </v-btn>
              </v-col>
            </v-row>
            <v-expand-transition>
              <div v-if="showInfo1" class="text-body-2">
                <p>
                  Staff will use a simple Tally System to document the
                  occurrence of seizures. If there are no seizures in a given
                  day, the documentation will be Ø (a zero with a slash through
                  it).
                </p>
                <p>
                  Examples: Ø = No Seizures I = 1 Seizures II = 2 Seizure III =
                  3 Seizures
                </p>
                <p>
                  Details regarding the seizure(s) will be documented in an
                  Incident Report.
                </p>

                <span
                  >Refer to the Seizure Protocol for a full set of guidelines.
                  General Protocol includes calling 911 if any of the following
                  occurs:</span
                >
                <ul v-for="(seizure, index) in seizureProtocols" :key="index">
                  <li>{{ seizure }}</li>
                </ul>
              </div>
            </v-expand-transition>
          </span>
        </v-alert>
      </div>

      <v-card class="pa-0 mb-3" outlined flat>
        <v-card-actions>
          <v-btn-toggle>
            <v-btn @click="togglePage('list')">
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
            <v-btn @click="togglePage('chart')">
              <v-icon>mdi-card-text-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="success"
            :loading="isDownloading"
            :disable="isDownloading"
            @click="generateReport"
          >
            download report
            <template v-slot:loader>
              <span>generating...</span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>

      <div class="tscroll" v-if="page === 'chart'">
        <table>
          <thead class="table-head">
            <tr>
              <th class="table-head-th"></th>
              <th
                class="table-head-th"
                v-for="(date, i) in chart.dates"
                :key="i"
              >
                {{ i + 1 }}
              </th>
            </tr>
          </thead>
          <tbody class="main-body">
            <template>
              <tr v-for="row in chart.items" :key="row.date">
                <td class="main-body--schedule">
                  <div class="main-body-td--content-schedule text-center">
                    {{ row.scheduled }}
                  </div>
                </td>
                <td
                  class="main-body--info"
                  v-for="cell in row.charts"
                  :key="cell.id"
                  :bgcolor="
                    userId === cell.records.staffId
                      ? 'green'
                      : userId !== cell.records.staffId &&
                        cell.records.type === ''
                      ? ''
                      : 'gray'
                  "
                  @click="selectCell(row, cell)"
                >
                  <div class="main-body-td--content text-center">
                    <span>
                      <span class="white--text text-h5">{{
                        cell.records.seizureType
                      }}</span>
                      <br />
                      <span class="text-caption white--text">{{
                        cell.records.staff
                      }}</span>
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div v-else>
        <ChartList @fetch-chart-data="fetch" />
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import FormDialog from "../chart/FormDialog";
import ClientNav from "@/components/ClientNav";
import ChartList from "./ChartList";
import download from "downloadjs";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ClientNav,
    ChartList,
    FormDialog,
  },
  data() {
    return {
      selectedCell: null,
      dialog: true,
      // charts: [],
      scheduledTime: ["Early AM", "AM", "Noon", "Early PM", "PM", "Late PM"],
      // dates: [],
      clientId: "",
      isLoading: false,
      scheduled: "",
      scheduledDate: "",
      selectedItemId: "",
      showInfo1: true,
      showInfo2: true,
      userId: "",
      page: "chart",
      seizureProtocols: [
        "The person has no history of seizures.",
        "The person has difficulty breathing or waking up after the seizure.",
        "The seizure lasts longer than 5 minutes.",
        "The person has three or more separate seizures within a 5-minute period.",
        "The person is injured or vomits during the seizure.",
        "The seizure happens in water.",
        "The person has a health condition like diabetes, heart disease, or is pregnant.",
      ],
      title: "Add Seizure Tracking",
      scheduleInitials: {
        "Early AM": "em",
        AM: "a",
        Noon: "n",
        PM: "p",
        "Early PM": "ep",
        "Late PM": "lp",
      },
      isDownloading: false,
    };
  },

  computed: {
    ...mapGetters("seizureItems", ["chart"]),

    showBMInfo() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.showInfo1 = false;
        this.showInfo2 = false;
      } else {
        this.showInfo1 = true;
        this.showInfo2 = true;
      }
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {
    showBMInfo(val) {
      return val;
    },
  },

  created() {
    this.fetch();
    this.userId = localStorage.getItem("userID");

    if (this.$route.query.id === undefined) {
      this.$router.back();
    }
  },
  methods: {
    ...mapActions({
      createItem: "seizureItems/createItem",
      updateItem: "seizureItems/updateItem",
      deleteItem: "seizureItems/deleteItem",
      downloadItem: "seizureItems/downloadItem",
      getChartItems: "seizureItems/getChartItems",
      getItem: "seizures/getItemById",
    }),

    selectCell(row, cell) {
      this.selectedCell = cell;
      this.scheduled = row.scheduled;
      this.scheduledDate = cell.date;
      this.selectedItemId = cell.records._id;

      if (cell.records.staffId === "") {
        this.$refs["form-dialog"].show();
      }

      if (cell.records.staffId === this.userId) {
        this.$refs["form-dialog"].show();
        this.$refs["form-dialog"].populateData(cell.records);
      }

      if (cell.records.staffId != this.userId) return;
    },

    async fetch() {
      try {
        this.isLoading = true;
        this.clientId = this.$route.params.clientID;
        await this.getChartItems(this.$route.query.id);
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async save(data) {
      const req_body = {
        ...data,
        scheduled: this.scheduled,
        scheduledDate: this.scheduledDate,
        clientId: this.clientId,
        seizureId: this.$route.query.id,
      };
      try {
        await this.createItem(req_body);
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    async update(data) {
      const req_body = {
        ...data,
        scheduled: this.scheduled,
        scheduledDate: this.scheduledDate,
        clientId: this.clientId,
        seizureId: this.$route.query.id,
      };
      try {
        await this.updateItem({ data: req_body, id: this.selectedItemId });
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    async generateReport() {
      this.isDownloading = true;
      try {
        const response = await this.downloadItem(this.$route.query.id);
        let pdfFile = "data:application/octet-stream;base64," + response;
        let fileName = `seizure-chart.pdf-${Date.now()}.pdf`;
        download(pdfFile, fileName, "application/pdf");
        this.isDownloading = false;
      } catch (e) {
        console.log(e);
        this.isDownloading = false;
      }
    },

    togglePage(page) {
      this.page = page;
    },
  },
};
</script>

<style scoped>
.tscroll {
  overflow-x: auto;
  margin-bottom: 10px;
}

.tscroll table td:first-child {
  position: sticky;
  left: 0;
}

.tscroll table,
thead,
tr,
th:first-child {
  position: sticky;
  left: 0;
}

.tscroll td,
.tscroll th {
  border-bottom: 1px dashed black;
  border-right: 1px dashed black;
}

.main-body {
  background-color: rgb(255, 255, 255);
}

.main-body--schedule {
  background-color: rgb(230, 228, 226);
}

.main-body-td--content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 7vh;
  min-width: 7vh;
}

.main-body-td--content-schedule {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 8vh;
  min-width: 8vh;
}

.table-head-th {
  border-top: 1px dashed black;
  background-color: rgb(230, 228, 226);
}

.main-body--info {
  transition: 0.3s;
}

.main-body--info:hover {
  background-color: gray;
  cursor: pointer;
}

ul {
  list-style-type: "- ";
}
</style>
